import { useState } from "react";
import UploadFile from "../../pages/Utils/UploadFile";
import { postData } from "../../services";
import { useLoading } from "../Loading";
import { useSnackbar } from "../../context/popup";

const BulkUpload = ({ categoryId, open, setOpen, endPoint, fetchList }) => {

  const [fileUploading, setFileUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);

  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleFileUploadSuccess = async (file) => {
    setCircleLoading(true);
    setFileUploading(true);
    setUploadSuccess(false);

    try {
      const formData = new FormData();

      formData.append("file", file);

      const result = await postData(endPoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (result?.success) {
        setUploadSuccess(true);
        showSnackbar(result?.message, "success");
        setOpen(false);
        setClearFileOnSuccess(true);
        fetchList(categoryId);
      } else {
        setUploadSuccess(false);
        showSnackbar("Faiiled to upload file", "error");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      console.error("Upload error:", error || errorMessage);
      showSnackbar(errorMessage || "Network Error", "error");
    } finally {
      setFileUploading(false);
      setCircleLoading(false);
    }
  };

  return (
    <UploadFile
      open={open}
      setOpen={setOpen}
      onUploadSuccess={handleFileUploadSuccess}
      fileTypes={["csv", "xlsx"]}
      fileUploading={fileUploading}
      uploadSuccess={uploadSuccess}
      setUploadSuccess={setUploadSuccess}
      setFileUploading={setFileUploading}
      clearFileOnSuccess={clearFileOnSuccess}
    />
  );
};

export default BulkUpload;
